module.exports = __webpack_public_path__ + "img/up-from-line.f2c11bf5.svg";